import { ServerPaginatedTable } from "../../../shared";
import React from "react";
import { Button, Chip } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import { sortItems } from "../../../utils";
import CloseIcon from "@mui/icons-material/Close";
import { useBirthdayCouponsV2ActiveCustomers } from "../hooks";

export const BirthdayCouponActiveCustomersV2 = ({ couponStatus }) => {
  const {
    state,
    gotoPage,
    setPageSize,
    handleSort,
    onChangeCustomerFilter,
    resetCustomerFilters,
    refreshData,
  } = useBirthdayCouponsV2ActiveCustomers();

  const { birthdayCouponCustomers, isLoading, filterApplied } = state;

  // Dynamic status options based on coupon status
  const statusOptions = React.useMemo(() => {
    if (!couponStatus) return [];

    const baseOption = couponStatus === 2
      ? { label: "Active", value: "Active" }
      : { label: "Paused", value: "Pause" };

    return [
      { label: "All Status", value: "" },
      baseOption,
      { label: "Redeemed", value: "Redeemed" },
    ];
  }, [couponStatus]);

  // Reload data when coupon status changes (play/pause button clicked)
  const previousCouponStatus = React.useRef(couponStatus);
  React.useEffect(() => {
    if (couponStatus && couponStatus !== previousCouponStatus.current && previousCouponStatus.current !== undefined) {
      // Status changed - reload the data
      refreshData();
      previousCouponStatus.current = couponStatus;
    } else if (couponStatus && previousCouponStatus.current === undefined) {
      // Initial mount
      previousCouponStatus.current = couponStatus;
    }
  }, [couponStatus, refreshData]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Email",
        accessor: "email",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Date of Birth",
        accessor: "date_of_birth",
        disableSortBy: true,
      },
      {
        Header: "Start Date",
        accessor: "start_from",
        disableSortBy: true,
      },
      {
        Header: "End Date",
        accessor: "end_till",
        disableSortBy: true,
      },
      {
        Header: "Status",
        accessor: "status",
        disableSortBy: true,
        Cell: ({ value }) => {
          return value === "Active" ? (
            <Chip
              label="Active"
              color="success"
              variant="outlined"
              size="small"
            />
          ) : value === "Pause" ? (
            <Chip label="Pause" color="info" variant="outlined" size="small" />
          ) : (
            <Chip
              label="Redeemed"
              color="warning"
              variant="outlined"
              size="small"
            />
          );
        },
      },
    ],
    [],
  );
  return (
    <>
      <ServerPaginatedTable
        columns={columns}
        data={birthdayCouponCustomers?.customers || []}
        key={state.sortBy}
        isLoading={isLoading}
        defaultSearch={false}
        gotoPage={gotoPage}
        setPageSize={setPageSize}
        pagination={state.pagination}
        handleSort={handleSort}
        sortByGlobal={state.sortBy}
        filterContent={
          <>
            <InputControl
              type="table-search"
              name="searchText"
              placeholder="Search"
              size="small"
              value={filterApplied.searchText}
              onChange={(e) => onChangeCustomerFilter(e)}
            />
            <InputControl
              type="select"
              name="status"
              label="Status"
              optionValue={statusOptions}
              width="250px"
              onChange={(e) => onChangeCustomerFilter(e)}
              value={filterApplied.status}
            />
            <Button
              type="button"
              size="medium"
              variant="text"
              color="gray"
              sx={{
                minWidth: "40px",
                p: "8px",
              }}
              disabled={!filterApplied.searchText && !filterApplied.status}
              onClick={() => resetCustomerFilters()}
            >
              <CloseIcon />
            </Button>
          </>
        }
        onRowLink={(e) => {
          return `/customers/details/${e.id}`;
        }}
      />
    </>
  );
};
